import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import { WrappedComponentProps, injectIntl } from "react-intl";

const SAPHEER_COLOR_2 = "#3D97F7";
const useStyles = makeStyles((theme) => ({
  heading: {
    marginTop: "1rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  word: {
    fontSize: ".95rem",
    lineHeight: 1.5,
    whiteSpace: "normal",
    overflowWrap: "break-word",

    color: SAPHEER_COLOR_2,
  },
  subTitle2: {
    fontSize: "0.98rem",
    display: "flex",
    color: "#4e5d78",
  },
}));

const ExplanationText: FC<WrappedComponentProps> = (props) => {
  const classes = useStyles();

  return (
    <Box className={classes.heading}>
      <Box>
        <Typography className={classes.subTitle2}>
          <Box mr={0.5}>Etape 1: </Box>
          <Box textAlign={"left"}>
            <span className={classes.word}>Paiement de votre package</span>
          </Box>
        </Typography>
        <Typography className={classes.subTitle2}>
          <Box mr={0.5}>Etape 2: </Box>
          <Box textAlign={"left"}>
            <span className={classes.word}>
              Choisissez votre type d'entreprise
            </span>
          </Box>
        </Typography>
      </Box>
    </Box>
  );
};

export default injectIntl(ExplanationText);
